// extracted by mini-css-extract-plugin
module.exports = {"container":"UserEventLayout_container__3r-C0"};